var clientGenerateOTPMapper = function (clientGenerateOTP) {
    if (clientGenerateOTP && clientGenerateOTP.data.msg)
        return {
            OTPSent: true,
            message: clientGenerateOTP.data.msg,
        };
    return {};
};
export default clientGenerateOTPMapper;
